export default "/images/stars.svg?7f66bea4707b6461bdf76fb484896e20";